/**
 * Lọc chứng từ khi chọn chứng từ in
 */
export default {
  All: 2,
  UnPrint: 0, // Chưa in
  Printed: 1, // Đã in
};
